import { Schema } from "mongoose"
import { z } from "zod"


export const ZRBRtsCounter = z.object({
  _id: z.string(),
  seq: z.number().int().min(0),
})

export type IRBRtsCounter = z.infer<typeof ZRBRtsCounter>

export const RBRtsCounterSchema: Schema = new Schema(
  {
    _id: { type: String, required: true },
    seq: { type: Number, required: true, default: 0 },
  },
  {
    versionKey: false,
  },
)
